import { Colors } from '@/common/colors/colors';
import Icon from '@/common/components/Icon';
import {
	CANDIDATE_RECRUITMENT_STATUSES,
	STATUSES_LABELS,
} from '@/common/constants/recruitmentStatuses';
import { compareDates } from '@/common/functions/compareDates';

export const getRaws = (candidates, setShowCandidateForm) => {
	return candidates
		.sort((a, b) =>
			compareDates(new Date(a.created_at), new Date(b.created_at)),
		)
		.sort((a, b) => {
			return (
				(STATUSES_LABELS.find((l) => l.value === a.status)?.weight ?? 999) -
				(STATUSES_LABELS.find((l) => l.value === b.status)?.weight ?? 999)
			);
		})
		.map((candidate, index) => {
			return (
				<tr
					style={{
						backgroundColor:
							candidate.status === CANDIDATE_RECRUITMENT_STATUSES.REJECTED &&
							Colors.darkGray2,
					}}
					key={candidate._id}
				>
					<td>{index + 1}</td>
					<td>
						{candidate.first_name} {candidate.last_name}
					</td>
					<td>{candidate.email}</td>
					<td>{candidate.phone}</td>
					<td>
						{STATUSES_LABELS.find((l) => l.value === candidate.status)?.label ||
							'----'}
					</td>
					<td>
						<Icon
							onClick={() => {
								setShowCandidateForm(candidate);
							}}
							name='fa fa-edit'
						/>
					</td>
				</tr>
			);
		});
};
